import { RootState } from '@/store/types';
import { KindMethodKeys } from '@/templates/NewRoutes';
import { localeList } from '@/heplers';

export const state: () => RootState = () => ({
  tree: {},
  content: {
    /* Контент страницы документации */
  },
  selectedLang: '',
  breadcrumbs: [],
  searchResult: {
    results: [
      {
        cat: '',
        results: [],
      },
    ],
    q: '',
    pagination: {
      page: 0,
      pageCount: 0,
      pageSize: 10,
      totalCount: 0,
    },
  },
  searchLinkInfo: {},
  selectedLanguagesPack: {
    voxengine: 'javascript',
    websdk: 'javascript',
    reactnative: 'javascript',
    http_api: 'curl',
    android: 'kotlin',
    androidsdk: 'java',
    androidsdk3: 'kotlin',
    unitysdk: 'csharp',
    fluttersdk: 'dart',
    iossdk: 'objc',
    kit: 'curl',
    kit_functions: 'javascript',
    avatarapi: 'grpc',
    imapi: 'grpc',
    avatarengine: 'javascript',
    'websdk-v5': 'javascript',
  },
  rootNames: {},
  treeLoading: true,
  contentLoading: true,
  currentTutorialFilter: '',
  isMobile: false,
  locale: localeList[0],
  isMobileCodeRails: false,
  pageRendered: false,
  notFound: false,
  toggleListeners: true,
  kindList: KindMethodKeys,
  progressBarStatus: false,
  pageIncludesCodeExamples: false,
  withByLink: false,
  redirects: {},
});
